import constants from '../services/constants';
import { atom } from 'recoil';

const editTeamAtom = atom<string>({
    key: constants.importSetCreatedAtom,
    default: '',
});

export default editTeamAtom;